import api from './api';
import { Product, ProductListResponse, ProductFilters } from '../types';

class ProductService {
  // 获取所有产品
  async getProducts(filters: ProductFilters = {}): Promise<ProductListResponse> {
    try {
      const params = new URLSearchParams();

      if (filters.search) params.append('search', filters.search);
      if (filters.minPrice) params.append('min_price', filters.minPrice.toString());
      if (filters.maxPrice) params.append('max_price', filters.maxPrice.toString());
      if (filters.sortBy) params.append('sort_by', filters.sortBy);
      if (filters.sortOrder) params.append('sort_order', filters.sortOrder);
      if (filters.limit) params.append('limit', filters.limit.toString());
      if (filters.offset) params.append('offset', filters.offset.toString());
      const response = await api.get(`/api/products?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching products:', error);
      throw new Error('获取产品列表失败');
    }
  }

  // 获取单个产品详情
  async getProduct(id: string): Promise<Product> {
    try {
      const response = await api.get(`/api/products/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching product:', error);
      throw new Error('获取产品详情失败');
    }
  }

  // 获取精选产品
  async getFeaturedProducts(limit: number = 6): Promise<Product[]> {
    try {
      const response = await api.get(`/api/products?featured=true&limit=${limit}`);
      return response.data.products;
    } catch (error) {
      console.error('Error fetching featured products:', error);
      return [];
    }
  }



  // 搜索产品
  async searchProducts(query: string, limit: number = 10): Promise<Product[]> {
    try {
      const response = await api.get(`/api/products/search?q=${encodeURIComponent(query)}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error searching products:', error);
      throw new Error('搜索产品失败');
    }
  }

  // 获取相关产品
  async getRelatedProducts(productId: string, limit: number = 4): Promise<Product[]> {
    try {
      const response = await api.get(`/api/products/${productId}/related?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching related products:', error);
      // 如果相关产品接口不存在，返回空数组
      return [];
    }
  }

  // 获取热门产品
  async getPopularProducts(limit: number = 8): Promise<Product[]> {
    try {
      const response = await api.get(`/api/products/popular?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching popular products:', error);
      // 如果热门产品接口不存在，返回空数组
      return [];
    }
  }

  // 获取新品
  async getNewProducts(limit: number = 6): Promise<Product[]> {
    try {
      const response = await api.get(`/api/products/new?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching new products:', error);
      // 如果新品接口不存在，返回空数组
      return [];
    }
  }

  // 上传图片
  async uploadImage(file: File): Promise<string> {
    try {
      const formData = new FormData();
      formData.append('image', file);
      
      const response = await api.post('/api/admin/upload-image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      return response.data.url;
    } catch (error) {
      console.error('Error uploading image:', error);
      throw new Error('图片上传失败');
    }
  }

  // 检查用户购买状态
  async checkPurchaseStatus(productId: string, email: string): Promise<any> {
    try {
      const response = await api.get(`/api/products/${productId}/purchase-status?email=${encodeURIComponent(email)}`);
      return response.data;
    } catch (error) {
      console.error('Error checking purchase status:', error);
      throw new Error('检查购买状态失败');
    }
  }
}

export const productService = new ProductService(); 